import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppMaintenanceComponent } from './app-maintenance.component';

const routes: Routes = [ { path: '', component: AppMaintenanceComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AppMaintenanceRoutingModule { }
